import { render } from "./ServerSideValidation.vue?vue&type=template&id=44c6b0c2"
import script from "./ServerSideValidation.vue?vue&type=script&lang=js"
export * from "./ServerSideValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__